import { render, staticRenderFns } from "./WritingCreditForm.vue?vue&type=template&id=7798cc46"
import script from "./WritingCreditForm.vue?vue&type=script&lang=js"
export * from "./WritingCreditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports